import React from 'react';
import { Tag, Input } from 'antd';

class EditableTagGroup extends React.Component {
    state = {
        tags: this.props.tags || [],
        inputValue: '',
    };

    handleClose = removedTag => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.props.handleTag(tags);
        this.setState({ tags });
    };

    handleInputChange = e => {
        this.setState({ inputValue: e.target.value });  
    };

    handleInputConfirm = () => {
        const { inputValue } = this.state;
        let { tags } = this.state;
        if (inputValue && tags.indexOf(inputValue) === -1) {
            tags = [...tags, inputValue];
        }
        this.props.handleTag(tags);
        this.setState({
            tags,
            inputValue: '',
        });
    };

    saveInputRef = input => {
        this.input = input;
    };

    render() {
        const { tags, inputValue } = this.state;
        return (
            <>
                {tags.map(tag => {
                    const tagElem = (
                        <Tag
                            className="edit-tag"
                            key={tag}
                            closable={true}
                            onClose={() => this.handleClose(tag)}
                        >
                            <span>{tag}</span>
                        </Tag>
                    );
                    return tagElem;
                })}
                <Input
                    ref={this.saveInputRef}
                    type="text"
                    size="small"
                    value={inputValue}
                    onChange={this.handleInputChange}
                    addonAfter={
                        <div onClick={this.handleInputConfirm}>
                            ADD
                        </div>
                    }
                    placeholder='Enter IP address. You can add multiple IPs'
                    className="api-key"
                />
                {this.props.isError
                    ? <div className='err-text'>Must provide atleast one trusted IP</div>
                    : null
                }
                <div className='ex-text'>Example: 192.168.10.1, 172.16.0.0/24, etc...</div>
            </>
        );
    }
}

export default EditableTagGroup;